import { render, staticRenderFns } from "./TableVariableMappingTable.vue?vue&type=template&id=da58ba96"
import script from "./TableVariableMappingTable.vue?vue&type=script&lang=js"
export * from "./TableVariableMappingTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports